import { render, staticRenderFns } from "./AccionEnviarAprobacion.vue?vue&type=template&id=7f4b327d&scoped=true&"
import script from "./AccionEnviarAprobacion.vue?vue&type=script&lang=js&"
export * from "./AccionEnviarAprobacion.vue?vue&type=script&lang=js&"
import style0 from "./AccionEnviarAprobacion.vue?vue&type=style&index=0&id=7f4b327d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4b327d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f4b327d')) {
      api.createRecord('7f4b327d', component.options)
    } else {
      api.reload('7f4b327d', component.options)
    }
    module.hot.accept("./AccionEnviarAprobacion.vue?vue&type=template&id=7f4b327d&scoped=true&", function () {
      api.rerender('7f4b327d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/acciones/AccionEnviarAprobacion.vue"
export default component.exports